export default __webpack_public_path__ + "static/golive-waves-517424ec3a3e3335d52abdc775f4874d.svg";